import { render, staticRenderFns } from "./pca.vue?vue&type=template&id=7c52d7fe&scoped=true&"
import script from "./pca.vue?vue&type=script&lang=js&"
export * from "./pca.vue?vue&type=script&lang=js&"
import style0 from "./pca.vue?vue&type=style&index=0&id=7c52d7fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c52d7fe",
  null
  
)

export default component.exports